import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import CaseStudies from "@/components/CaseStudies";
import Testimonials from "@/components/Testimonials";
import SEOHead from "@/components/SEOHead";
import SkipLink from "@/components/SkipLink";
import { useSEO } from "@/hooks/useSEO";

const CaseStudiesPage = () => {
  useSEO({
    title: "Success Stories & Client Testimonials | Smartborn Case Studies",
    description: "Explore Smartborn's successful project implementations across banking, e-commerce, healthcare, and enterprise sectors. Read what our clients say about working with us.",
    keywords: "case studies, success stories, client testimonials, project portfolio, banking modernization, e-commerce solutions, healthcare integration, digital transformation",
    canonical: "https://smartborn.io/case-studies",
    ogType: "website"
  });

  return (
    <>
      <div className="min-h-screen">
        <SEOHead />
        <SkipLink />
        <Navigation />
        <main id="main-content" tabIndex={-1}>
          <CaseStudies />
          <Testimonials />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default CaseStudiesPage;
